import React from "react"
import PlanSite from "gatsby-theme-blank/src/pages/plan-site"

const PlanSiteCactus = () => <PlanSite arianeDisplayed={true} />

export default PlanSiteCactus
